import { Cpu } from "./Cpu.js";
import { Box } from "./Box.js";
import React, { setState } from 'react';
import { styles, mobileStyles } from '../Style.js';


export class TicTacToe extends React.Component {
    constructor(props) {
        super(props);
        // Note: board[0] will always be null
        this.state = {
            board: [null,
                "", "", "", 
                "", "", "", 
                "", "", ""
            ],
            turn: "X",
            first: "X",
            cpu: new Cpu("O", "smart"),
            cpuDumb: new Cpu("X", "smart")
        };

        //bind methods
        this.toggleTurn = this.toggleTurn.bind(this);
        this.tieGame = this.tieGame.bind(this);
        this.winGame = this.winGame.bind(this);
        this.movePlayer = this.movePlayer.bind(this);
        this.moveCpu = this.moveCpu.bind(this);
        this.makeMove = this.makeMove.bind(this);
        this.updateIntellimeter = this.updateIntellimeter.bind(this);
        this.resetBoard = this.resetBoard.bind(this);

        // True while a finished board is held on screen before its delayed reset.
        this.resetPending = false;
    }

    componentDidMount() {
        setInterval(() => {
            this.makeMove({});
        }, this.props.delay);
    }
    
    componentDidUpdate() {
        if (this.props.AINeedsReset) {
            this.setState({
                ...this.state,
                cpu: new Cpu("O", "smart")
            });
            this.props.AIHasBeenReset();
        }
    }
  
    toggleTurn () {
        return this.state.turn === "X" ? "O" : "X";
    }
    toggleFirst() {
        return this.state.first === "X" ? "O" : "X";
    }
    tieGame () {
        return (
            this.state.board[1] !== "" && 
            this.state.board[2] !== "" && 
            this.state.board[3] !== "" && 
            this.state.board[4] !== "" && 
            this.state.board[5] !== "" && 
            this.state.board[6] !== "" && 
            this.state.board[7] !== "" && 
            this.state.board[8] !== "" && 
            this.state.board[9] !== ""
        ) ? "tie" : false;
    }
    winGame (char) { // return boolean
        if (     this.state.board[1] === char && this.state.board[2] === char && this.state.board[3] === char) return char;
        else if (this.state.board[4] === char && this.state.board[5] === char && this.state.board[6] === char) return char;
        else if (this.state.board[7] === char && this.state.board[8] === char && this.state.board[9] === char) return char;
        else if (this.state.board[1] === char && this.state.board[4] === char && this.state.board[7] === char) return char;
        else if (this.state.board[2] === char && this.state.board[5] === char && this.state.board[8] === char) return char;
        else if (this.state.board[3] === char && this.state.board[6] === char && this.state.board[9] === char) return char;
        else if (this.state.board[1] === char && this.state.board[5] === char && this.state.board[9] === char) return char;
        else if (this.state.board[3] === char && this.state.board[5] === char && this.state.board[7] === char) return char;
        else return false;
    }
    movePlayer (index) {
        if (this.state.board[index] !== "") return false;
        return index;
    }
    moveCpu (mCpu) {
        return mCpu.getMove(this.state.board);
    }
    makeMove ({keypad}) {
        let gameResult = this.winGame("X") || this.winGame("O") || this.tieGame();
        if (gameResult) {
            // A delayed reset is already scheduled - keep showing the final board.
            if (this.resetPending) return;

            // Tally the result and let the AI learn (once per game).
            if (gameResult === "X") this.props.winX();
            else if (gameResult === "O") this.props.winO();
            else if (gameResult === "tie") this.props.tie();
            this.state.cpu.giveGameResult(gameResult, this.state.board);
            if (this.props.playerX == "dumbCpu") {
                this.state.cpuDumb.giveGameResultTraining(gameResult, this.state.board);
            }
            this.updateIntellimeter();
            this.props.updateParent();

            // Training mode resets instantly to keep self-play fast; when a human
            // is playing, leave the finished board up for half a second first.
            if (this.props.playerX == "dumbCpu") {
                this.resetBoard();
            } else {
                this.resetPending = true;
                setTimeout(this.resetBoard, 500);
            }
            return;
        }
        
        // players move
        let move;
        let char;
        if (this.state.turn === "X") {
            char = "X";
            if(this.props.playerX === "player") {
                move = this.movePlayer(parseInt(keypad));
            } else if (this.props.playerX === "dumbCpu") {
                move = this.moveCpu(this.state.cpuDumb);
            } else { // props.playerX == "smartCpu"
                move = this.moveCpu(this.state.cpu);
            }
        } else { // turn == "O"
            char = "O";
            if(this.props.playerO === "player") {
                move = this.movePlayer(parseInt(keypad));
            } else if (this.props.playerO === "dumbCpu") {
                move = this.moveCpu(this.state.cpuDumb);
            } else { // props.playerO == "smartCpu"
                move = this.moveCpu(this.state.cpu);
            }
        }
        if (move === false) return; // Invalid move (if the player clicks on a marked square)
        const nextTurn = this.toggleTurn();
        const nextFirst = this.toggleFirst();
        this.setState({
            ...this.state,
            board: [
                ...this.state.board.slice(0, move),
                char,
                ...this.state.board.slice(move + 1)
            ],
            turn: nextTurn,
            first: nextFirst
        });
    }
    updateIntellimeter () {
        this.props.updateIntellimeter(this.state.cpu.getIntellimeter());
    }
    resetBoard () {
        this.setState({
            ...this.state,
            turn: this.state.first,
            board: [null,
                "", "", "",
                "", "", "",
                "", "", ""
            ]
        }, () => { this.resetPending = false; });
    }

    render () {
        return (
        <div style={this.props.isMobile ? {...styles.TicTacToe, ...mobileStyles.TicTacToe} : styles.TicTacToe}>
            <div style={styles.row}>
                <Box keypad="7" status={this.state.board[7]} handleClick={this.makeMove} />
                <Box keypad="8" status={this.state.board[8]} handleClick={this.makeMove} />
                <Box keypad="9" status={this.state.board[9]} handleClick={this.makeMove} />
            </div>
            <div style={styles.row}>
                <Box keypad="4" status={this.state.board[4]} handleClick={this.makeMove} />
                <Box keypad="5" status={this.state.board[5]} handleClick={this.makeMove} />
                <Box keypad="6" status={this.state.board[6]} handleClick={this.makeMove} />
            </div>
            <div style={styles.row}>
                <Box keypad="1" status={this.state.board[1]} handleClick={this.makeMove} />
                <Box keypad="2" status={this.state.board[2]} handleClick={this.makeMove} />
                <Box keypad="3" status={this.state.board[3]} handleClick={this.makeMove} />
            </div>
        </div>
        );
    }
}